import TableSizesModal from "./TableSizesModal";

export default TableSizesModal;
